/*HCORZ
=========================================================================================
* Descripción: 
* Historial de cambios:
* ---------------------------------------------------------------------------------------
*    Revisión   | Fecha      | Desarrollador                    | Resumen del cambio
* ---------------------------------------------------------------------------------------
*      1       | 11/07/2025 | Lic. José Luis Aragón Cervantes  | Creación
* --------------------------------------------------------------------------------------- */

import { Backdrop, CircularProgress, Typography } from "@mui/material";

import { useLayout } from "../../context/System/LayoutContext";

export default function HcorzLoader() {
    const {
        loader: { open, message },
    } = useLayout();

    return (
        <Backdrop
            open={open}
            sx={{
                backgroundColor: "rgba(255, 255, 255, 0.6)",
                zIndex: (theme) => theme.zIndex.modal + 1,
            }}
        >
            <div className="sizesoftx-loader">
                <CircularProgress color="inherit" />
                <Typography>{message}</Typography>
            </div>
        </Backdrop>
    );
}
